<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
<!--    <div>{{json}}}</div>-->
  </div>
</template>

<script>

export default {
  name: 'app',
  data () {
    return {
      videoList:{},
      json:""
    }
  },
  beforeCreate () {
    let that = this
    this.$axios.get("240words/homeInfo/1/0").then((response) => {
      that.videoList = response.data;
      that.json = JSON.stringify(response.data)
    }).catch(function (error) {
      alert(error)
    });
  }
}


</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0px;
  padding: 0px;
}
</style>
